import React, { Component } from 'react'
import { Link } from 'react-router-dom'

import Header from '../components/Header/Header.js'
import Footer from '../components/Footer/Footer.js'
import Button from '../components/Button/Button.js'

class BecomeAPartner extends Component {
  
  componentDidMount(){
    window.document.title = "Become a Partner - Pattycake";
  }
  
  render(){
    return <div>
      <Header transparent={true}/>
        
        <div className="container">
          <div className="row row-mega-padded">
            <div className="col-md-12 text-center">
              <h1>Pattycake Partner Program</h1>
              <p className="lead">
                Introduce your materials to thousands of architects and designers.
              </p>
            </div>
          </div>
          <div className="row row-push-down justify-content-center row-eq-height">
            <div className="col-md-6">
              <div className="col-themed col-themed-invisible">
                <i className="fal duotone-pattycake fa-books fa-4x text-primary"></i>
                <br/>
                <br/>
                <h3>Feature your materials in our library</h3>
                <p>
                  Manufacture tile, stone, metal panels or anything else that leverages .PAT files? Upload your existing .PAT files and we'll make them easily accessible via our library.
                </p>
              </div>
            </div>

            <div className="col-md-6">
              <div className="col-themed col-themed-invisible">
                <i className="fal duotone-pattycake fa-copyright fa-4x text-primary"></i>
                <br/>
                <br/>
                <h3>Your patterns, your branding, our users</h3>
                <p>
                  Putting your material specs in front of Pattycake users makes them more likely to end up in construction drawings around the globe. Keep your brand and links to your website alongside your pattern data, even when downloaded. 
                </p>
              </div>
            </div>
          </div>
        </div>
        
        <div className="section-breaker">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-5">
                <div className="flex-center-column">
                  <h3>Want to learn more?</h3>
                  <br/>
                  <Link to="/contact" className="button-link">
                    <Button
                      display={<span>Get in touch&nbsp; <i className="fal fa-angle-double-right"/></span>}
                      color="primary"
                      size="large"
                    />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      <Footer/>
    </div>
  }
}

export default BecomeAPartner
  


// WEBPACK FOOTER //
// ./src/routes/BecomeAPartner.js